module.exports = __webpack_public_path__ + "static/media/studio_articulated_loader_mla_4_50_h_c_canopy_manitou_003.421c4fd3.png";